export const getDDLPrice = (babelProdotto, config) => {
  const { productMsrpPrice, productSellingPrice, productOmnibusPrice, shopLink } = babelProdotto;
  return productSellingPrice
    ? {
        sellingPrice: {
          currency: config?.currency,
          value: parseFloat(productSellingPrice.replace(",", ".")),
        },
        ...(productMsrpPrice && {
          msrpPrice: {
            value: parseFloat(productMsrpPrice.replace(",", ".")),
            currency: config?.currency,
          },
        }),
        ...(productOmnibusPrice && {
          omnibusPrice: {
            value: parseFloat(productOmnibusPrice.replace(",", ".")),
            currency: config?.currency,
          },
        }),
        shopLink,
      }
    : shopLink
    ? { sellingPrice: undefined, shopLink }
    : undefined;
};
